import { createIcon } from './icon';

export const DateIcon = createIcon(
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.33333 12C0.966667 12 0.652778 11.8825 0.391667 11.6475C0.130556 11.4125 0 11.13 0 10.8V2.4C0 2.07 0.130556 1.7875 0.391667 1.5525C0.652778 1.3175 0.966667 1.2 1.33333 1.2H2V1C2 0.447716 2.44772 0 3 0C3.55228 0 4 0.447716 4 1V1.2H8V1C8 0.447716 8.44772 0 9 0C9.55229 0 10 0.447716 10 1V1.2H10.6667C11.0333 1.2 11.3472 1.3175 11.6083 1.5525C11.8694 1.7875 12 2.07 12 2.4V10.8C12 11.13 11.8694 11.4125 11.6083 11.6475C11.3472 11.8825 11.0333 12 10.6667 12H1.33333ZM1.33333 10.1333C1.33333 10.5015 1.63181 10.8 2 10.8H10C10.3682 10.8 10.6667 10.5015 10.6667 10.1333V4.8H1.33333V10.1333ZM1.33333 3.6H10.6667V2.4H1.33333V3.6Z"
      fill="currentColor"
    />
  </svg>,
  'DateIcon'
);
